<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.groups', 2),
                        href: meta.links.index,
                    },
                    {
                        name: group.name,
                        href: null,
                    },
                ]"
            >
                <template v-slot:corner>
                    <div class="flex space-x-1 items-center">
                        <BadgePill>
                            <InertiaLink :href="meta.links.graphs">{{ $t('messages.graphs') }}</InertiaLink>
                        </BadgePill>
                        <BadgePill>
                            <InertiaLink :href="meta.links.grades_overview">{{ $t('messages.graphs') }} 2</InertiaLink>
                        </BadgePill>
                        <ActivityMenuOptions>
                            <InertiaLink
                                v-for="otherGroup in meta.links.other_groups"
                                :href="otherGroup.url"
                                :key="otherGroup.url"
                                class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                role="menuitem"
                            >
                                {{ otherGroup.text }}
                            </InertiaLink>
                        </ActivityMenuOptions>
                    </div>
                </template>
            </SmartBreadcrumbs>
        </template>

        <div>
            <div v-if="options.practice_mode_settings.settings.is_active">
                <AlertMessage class="mt-5 inline-block" type="info">
                    <template v-slot:title>
                        <span>{{ options.practice_mode_settings.settings.mode_display }}.</span>
                    </template>
                    <template v-slot:body>
                        <div class="ml-3 text-lg">
                            {{ $t('messages.time_left') }}
                            <span>
                                <CountdownTimer
                                    class="inline-block"
                                    :datetime="options.practice_mode_settings.settings.ends_at"
                                />
                            </span>
                        </div>
                    </template>
                </AlertMessage>
            </div>
        </div>

        <div class="w-full flex justify-end space-x-2 flex-wrap">
            <ActivityModeGroupPanel :settings="options.practice_mode_settings" />

            <div v-for="link in links" :key="link.href">
                <AppButton
                    :href="link.href"
                    :element="link.element ?? 'InertiaLink'"
                    :desired-action="link.desired_action"
                >
                    {{ link.text }}
                </AppButton>
            </div>
        </div>

        <div class="md:grid md:grid-cols-4 md:gap-6">
            <div class="">
                <div class="mt-1">
                    <FormLabel :value="$tc('messages.columns', 2)" for="show" />
                    <FormSelect
                        id="avatar"
                        v-model="settings.columns"
                        :options="columnOptions"
                        class="mt-1 w-full"
                        :null-option="false"
                    />
                </div>
            </div>
        </div>

        <div>
            <div class="mt-6 grid grid-cols-1 gap-y-2 gap-x-4 sm:grid-cols-2" :class="settings.columns">
                <div class="relative col-span-1 flex shadow rounded-md" v-for="student in students" :key="student.id">
                    <div
                        class="shrink-0 flex items-center justify-center w-16 text-white text-sm leading-5 font-medium rounded-l-md overflow-hidden"
                    >
                        <InertiaLink :href="student.links.show">
                            <img :src="student.avatar_or_default" alt="profile photo" />
                        </InertiaLink>
                    </div>
                    <div
                        class="flex-1 flex flex-col justify-start border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate"
                    >
                        <div class="flex flex-1 justify-between px-4 pt-1 text-sm leading-5 truncate">
                            <InertiaLink
                                :href="student.links.show"
                                class="text-gray-900 font-medium hover:text-gray-600 transition ease-in-out duration-150"
                            >
                                {{ student.index }}. {{ student.full_name }}
                            </InertiaLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import BadgePill from '@/components/BadgePill.vue';
import AppButton from '@/components/AppButton.vue';
import ActivityMenuOptions from '@/components/pageSpecific/ActivityMenuOptions.vue';
import AlertMessage from '@/components/AlertMessage.vue';
import CountdownTimer from '@/components/CountdownTimer.vue';
import ActivityModeGroupPanel from '@/components/ActivityModeGroupPanel.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';

export default {
    components: {
        FormSelect,
        FormLabel,
        ActivityModeGroupPanel,
        CountdownTimer,
        AlertMessage,
        PanelPage,
        BadgePill,
        AppButton,
        ActivityMenuOptions,
    },
    layout: Layout,
    name: 'Show',
    props: ['teacher', 'meta', 'options', 'group', 'students', 'links'],
    data() {
        return {
            settings: {
                show: 'distinguish_absent_students',
                avatar: 'avatar_or_profile_photo',
                columns: 'md:grid-cols-4 lg:grid-cols-4',
            },
            columnOptions: [
                {
                    value: 'md:grid-cols-2 lg:grid-cols-2',
                    text: 2,
                },
                {
                    value: 'md:grid-cols-3 lg:grid-cols-3',
                    text: 3,
                },
                {
                    value: 'md:grid-cols-4 lg:grid-cols-4',
                    text: 4,
                },
                {
                    value: 'md:grid-cols-5 lg:grid-cols-5',
                    text: 5,
                },
                {
                    value: 'md:grid-cols-6 lg:grid-cols-6',
                    text: 6,
                },
            ],
        };
    },
    watch: {
        'settings.columns': {
            handler(newVal) {
                localStorage.setItem('Teacher/Gamification/Groups/Show_settings_columns', newVal);
            },
            deep: true,
        },
    },
};
</script>
